module.exports = {
      id: "corona-updates-icon-usage",
      viewBox: "0 0 25.374 25.18",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#corona-updates-icon",
      toString: function () {
        return this.url;
      }
    }